import { DetailedDrop_LiveShow } from '@aboutyou/legacy-shared/src/grpc_client/grips/protos/shared/detailed_drop'
import {
  normalizeLiveShowState,
  useAutoplayLiveShow,
} from '@aboutyou/legacy-shared/src/pages/Live/LiveShopping/hooks/useAutoplayLiveShow'
import React from 'react'
import styled from 'styled-components'
import { bordersColor } from 'uiComponents/constants/colors'
import { LiveShow } from './LiveShow'

export const LiveShows: React.FC<{
  liveShows: DetailedDrop_LiveShow[]
}> = ({ liveShows }) => {
  const { updateShowIdAndAutoplay } = useAutoplayLiveShow({
    liveShows: liveShows.map(item => ({
      id: item.id,
      state: normalizeLiveShowState(item.state),
    })),
  })

  if (!liveShows) {
    return null
  }

  return (
    <Wrapper>
      {liveShows?.map(liveShow => (
        <LiveShow
          key={liveShow.id}
          liveShow={liveShow}
          startLiveShow={updateShowIdAndAutoplay}
        />
      ))}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  & > *:last-child {
    border-bottom: 1px solid ${bordersColor};
    padding-bottom: 32px;
  }
`
